export default "__VITE_ASSET__566eddb6__"